var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 30,
    viewBox: "0 0 22 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7475 4.67356V27.3927C20.7475 27.5661 20.7123 27.7378 20.6438 27.8978C20.5754 28.0579 20.475 28.2031 20.3486 28.3253C20.2222 28.4474 20.0723 28.544 19.9073 28.6095C19.7424 28.6749 19.5657 28.708 19.3876 28.7067H2.47218C2.11411 28.7067 1.77069 28.5683 1.51749 28.3219C1.2643 28.0755 1.12207 27.7412 1.12207 27.3927V3.03582C1.12207 2.68732 1.2643 2.35308 1.51749 2.10665C1.77069 1.86023 2.11411 1.7218 2.47218 1.7218H17.6657L20.7475 4.67356Z",
    fill: "white",
    stroke: "#AA013F",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90039 9.49585L8.93615 11.5316C9.39825 11.162 9.95948 10.9217 10.5776 10.8522V7.97095C9.16988 8.05343 7.89172 8.61399 6.90039 9.49585Z",
    fill: "#02006B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39404 10.0018C5.43758 11.077 4.82715 12.4881 4.82715 14.0369C4.82715 14.2348 4.98722 14.3948 5.18504 14.3948H7.35628C7.55411 14.3948 7.71418 14.2348 7.71418 14.0369C7.71418 13.2779 7.98897 12.5887 8.42981 12.0376L6.39404 10.0018Z",
    fill: "#02006B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7008 11.2391C13.5802 11.1339 13.4055 11.1203 13.2723 11.2066L10.1662 13.188C9.75136 13.4529 9.50391 13.9041 9.50391 14.3955C9.50391 15.1851 10.1459 15.8271 10.9355 15.8271C11.4905 15.8271 12.0001 15.5021 12.2336 14.9991L13.7892 11.6592C13.8563 11.5152 13.8203 11.344 13.7008 11.2391Z",
    fill: "#02006B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4772 10.0018L14.4252 11.0538C14.5577 11.3365 14.5751 11.6675 14.4384 11.9609L13.9678 12.9712C14.0889 13.304 14.157 13.6618 14.157 14.0369C14.157 14.2348 14.3171 14.3948 14.5149 14.3948H16.6862C16.884 14.3948 17.0441 14.2348 17.0441 14.0369C17.0441 12.4881 16.4336 11.077 15.4772 10.0018Z",
    fill: "#02006B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.293 7.97095V10.8522C11.5943 10.8861 11.8814 10.9619 12.1508 11.0721L12.8871 10.6024C13.1821 10.4113 13.5425 10.3702 13.9179 10.5481L14.9702 9.49585C13.9789 8.61399 12.7007 8.05343 11.293 7.97095Z",
    fill: "#02006B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8778 5.46008H16.5645V1.14673",
    fill: "#AA013F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8778 5.46008H16.5645V1.14673",
    stroke: "#AA013F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65137 19.4497H10.2906",
    stroke: "#AA013F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55566 23.0454H12.85",
    stroke: "#AA013F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditReport);
export default __webpack_public_path__ + "static/media/CreditReport.e6dd51fcad9d43bc145b7ecc72931dd6.svg";
export { ForwardRef as ReactComponent };